// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7405b0cc","239":"1bec6fb8","455":"03edbe20"}[chunkId] + ".chunk.js";
};